import React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/lib/select/';

export const LANGUAGE_CODES = [
  'EN',
  'EN-AR',
  'EN-FA',
  'EN-HT',
  'EN-IL',
  'EN-JP',
  'EN-KEA',
  'EN-KR',
  'EN-PT',
  'EN-RU',
  'EN-SP',
  'EN-TC',
  'EN-TL',
  'EN-VI',
] as const;

export type LanguageCode = typeof LANGUAGE_CODES[number];

const LANGUAGE_NAMES: Record<LanguageCode, string> = {
  EN: 'English',
  'EN-AR': 'English/Arabic',
  'EN-FA': 'English/Farsi',
  'EN-HT': 'English/Haitian Creole',
  'EN-IL': 'English/Ilocano',
  'EN-JP': 'English/Japanese',
  'EN-KEA': 'English/Cape Verdean Creole',
  'EN-KR': 'English/Korean',
  'EN-PT': 'English/Portuguese',
  'EN-RU': 'English/Russian',
  'EN-SP': 'English/Spanish',
  'EN-TC': 'English/Traditional Chinese',
  'EN-TL': 'English/Tagalog',
  'EN-VI': 'English/Vietnamese',
};

export const getLanguageLabel = (
  language: LanguageCode | null | undefined
): string => (language ? `${language} (${LANGUAGE_NAMES[language]})` : '');

const LANGUAGE_OPTIONS = LANGUAGE_CODES.map((code) => ({
  value: code,
  label: getLanguageLabel(code),
}));

const LanguageSelect: React.FC<SelectProps<string>> = (props) => (
  <Select {...props} options={LANGUAGE_OPTIONS} />
);

export default LanguageSelect;
